interface StatsCardProps {
  label: string;
  value: number | string;
  icon: string;
  color: string;
  sub?: string;
}

export default function StatsCard({ label, value, icon, color, sub }: StatsCardProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5">
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${color}`}>
          <i className={`${icon} text-lg`}></i>
        </div>
      </div>
      <div className="text-2xl font-bold text-[#1B2838] mb-0.5">{value}</div>
      <div className="text-sm text-gray-500">{label}</div>
      {sub && <div className="text-xs text-gray-400 mt-1">{sub}</div>}
    </div>
  );
}
